module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.preregistrations')))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.filterControllers
    },
    model: {
      value: (_vm.selectedControllerId),
      callback: function($$v) {
        _vm.selectedControllerId = $$v
      },
      expression: "selectedControllerId"
    }
  }, _vm._l((_vm.filterControllers()), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(item.label),
        "value": item.value
      }
    })
  })), _vm._v(" "), (_vm.hasPermission('CREATE_PREREGISTRATION')) ? _c('el-button', {
    attrs: {
      "disabled": !_vm.selectedControllerId,
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v(_vm._s(_vm.$t('button.new')))]) : _vm._e(), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "preregistrations",
      "columns": ['contact_name', 'controllerName', 'regcode'],
      "operations": _vm.operations
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.remove'),
      "visible": !!_vm.modelToDelete,
      "width": "30%",
      "before-close": function () {
        _vm.modelToDelete = null
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.modelToDelete = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteModel
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ddbbd6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preregistration/PreregistrationList.vue
// module id = 1133
// module chunks = 2